"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentProviderGroupSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        width: 980,
        maxWidth: '100%',
        margin: '0 auto'
    };
});
const Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3)
    };
});
const SkeletonText = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        borderRadius: theme.shape.largeComponentRadius
    };
});
const PaymentProviderGroupSkeleton = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        ...getTestIdProps(_models.TestId.SkeletonPaymentProviders),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                animation: "wave",
                variant: "rounded",
                width: 158,
                height: 21
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                        animation: "wave",
                        variant: "rounded",
                        width: "100%",
                        height: 65
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                        animation: "wave",
                        variant: "rounded",
                        width: "100%",
                        height: 65
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                        animation: "wave",
                        variant: "rounded",
                        width: "100%",
                        height: 65
                    })
                ]
            })
        ]
    });
};
exports.PaymentProviderGroupSkeleton = PaymentProviderGroupSkeleton;
